import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getReports, getVendors } from '../../../store/Admin/reports/report.actions'
import StateSelectors from '../../../utils/Admin/constants/selector.constants'
import './reportspage.css'
import DatePicker from "react-datepicker";
import downloadIcon from '../../../assets/Admin/download-icon.svg'
import "react-datepicker/dist/react-datepicker.css";
import Table from '../../../components/Admin/Table/Table'
import downloadFile from '../../../utils/Admin/helpers/download'
import formatDate from '../../../utils/Admin/helpers/formatDate'
import { resetAllReduxState } from '../../../store/Admin/authentication/authentication.actions'
import CModal from '../../../components/Admin/custom-modal/CModal'
import { hideLoader, showLoader } from '../../../store/Admin/Loader/loader.slice'
import { resetReport } from '../../../store/Admin/reports/reports.slice'

const ReportsPage = () => {

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const modalRef = useRef()

  const reports = useSelector(StateSelectors.REPORTS_SELECTOR)

  const { tokenExpired } = useSelector(StateSelectors.USER_SELECTOR)


  const [selectedValues, setSelectedValues] = useState({
    vendorName: 'All',
    fromDate: new Date(),
    toDate: new Date(),
    source: 'All',
    accountStatus: 'All'
  })

  const [dateRange, setDateRange] = useState([null, null]);
  const [tableData, setTableData] = useState([])
  const [downloadData, setDownloadData] = useState([])
  const [startDate, endDate] = dateRange;
  const [searchValue, setSearchValue] = useState('')
  const [noData, setNoData] = useState(false) 

  useEffect(() => {
    setTableData(reports.reports)
  }, [reports])


  useEffect(() => {
    if (reports.isLoading === false) {
      dispatch(hideLoader())
    } else {
      dispatch(showLoader('Getting data...'))
    }

    if (reports.isEmpty) {
      modalRef.current.showModalContent('failure', 'No data found for the selected filters', true)
    }
    
    if (reports.hasError === 1 || reports.hasError === 2) {
      modalRef.current.showModalContent('failure', 'Unable to retreive data', true)
    }

  }, [reports.isLoading, reports.isEmpty])

  useEffect(() => {
    if (tokenExpired === true) {
      dispatch(hideLoader())
      modalRef.current.showModalContent('failure', 'Token expired. Navigating to login screen', true)
    }

  }, [tokenExpired])

  useEffect(() => {
    dispatch(getVendors())
  }, [])


  const handleLoginRedirection = () => {
    sessionStorage.clear()
    dispatch(hideLoader())
    dispatch(resetAllReduxState())
    navigate('login')
  }  

  const onSelectDropdown = (ev) => {

    setSelectedValues({
      ...selectedValues,
      [ev.target.ariaLabel]: ev.target.innerText
    })
  
  }

  const handleSearch = (ev) => {
    setNoData(false)
    if (reports.reports.length === 0) {
      return
    }
    let searchText = ev.target.value.toLowerCase()
    setSearchValue(searchText)
    if (searchText.length === 0) { 
      setTableData(reports.reports)
      return
    }

    let report = reports.reports

    let matches = report.filter((item) => {
      return Object.values(item).some( objValue => {
        let value  = objValue.toString().replace(/\s/g, '').toLowerCase()
        if (value.includes(searchText.replace(/\s/g, '').toLowerCase())) {
         return item
        }
        
      } )
    })

    if (matches.length === 0) {
      setNoData(true)
    }

    setTableData(matches)
    setDownloadData(matches)
  }

  const resetDropdowns = () => {
    setSelectedValues({
      vendorName: 'All',
      fromDate: new Date(),
      toDate: new Date(),
      source: 'All',
      accountStatus: 'All'
    })
    setDateRange([null, null])
    setTableData([])
    setDownloadData([])
    dispatch(resetReport())
    setNoData(false)
    setSearchValue('')
    setTableData([])
  } 

  const onClickDownload = () => {
    let fileName = reports.selectedVendor?.length === 0 ? 'outputTOT' : reports.selectedVendor + '-outputTOT'
    if (downloadData.length === 0) {
      downloadFile(fileName, 'xlsx', tableData)
      return
    }
    downloadFile(fileName, 'xlsx', downloadData)
  }

  const setFilteredDataToDownload = (data) => {
    setDownloadData(data)
  }


  const handleSubmitFilters = () => {
    
    const payload = {
      FROM_DATE : startDate === null ? '' : formatDate(startDate.toString()),
      TO_DATE : endDate === null ? '' : formatDate(endDate.toString()),
      BROKER_NAME: selectedValues.vendorName === 'All' ? '' : selectedValues.vendorName.toUpperCase(),
      ACCOUNT_STATUS: selectedValues.accountStatus === 'All' ? '' : selectedValues.accountStatus,
      SOURCE: selectedValues.source === 'All' ? '' : selectedValues.source
    }

    if (payload.FROM_DATE.length === 0 || payload.TO_DATE.length === 0) {
      modalRef.current.showModalContent('failure', 'Please select valid date range', true)
      return 
    }

    // if (payload.FROM_DATE.length !== 0 && payload.TO_DATE.length === 0) {
    //   modalRef.current.showModalContent('failure', 'Please select valid date range', true)
    // } else if(payload.FROM_DATE.length === 0 && payload.TO_DATE.length !== 0){
    //   modalRef.current.showModalContent('failure', 'Please select valid date range', true)
    // } else {  
    //   dispatch(getReports(payload))
    //   setTableData([])
    //   setDownloadData([]) 
    // }
    
    dispatch(getReports(payload))
    setTableData([])
    setDownloadData([]) 

  }

  return (
    <div className="reports-section bg-custom-grey px-3 h-100">
      <div className="bg-white mx-1 mx-xl-5 mt-4">
        <div className="row align-items-end px-4 no-row-margin pb-3">
          <h3 className='col-12 section-header py-3'>MIS reports</h3>
         
          <div className="col-3 col-md-3 col-lg-2 col-xl-2">
            <p className="mb-1 text-capitalize report-dropdown-label">select distributor</p>
            <div className="dropdown admin-dropdown select-dist-dropdown w-100 my-1">
              <button className="btn dropdown-toggle w-100 text-start no-shadow dropdown-icon-shape dropdown-button-padding" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                { selectedValues.vendorName.length ? selectedValues.vendorName : 'All' }
              </button>
              
              <ul className="dropdown-menu w-100 dropdown-scroll background-white" aria-labelledby="dropdownMenuButton1">
                <li aria-label="vendorName" onClick={onSelectDropdown} className={selectedValues.vendorName === 'All' ? "text-capitalize px-2 py-1 cursor-pointer fw-bold" : "text-capitalize px-2 py-1 cursor-pointer"}>All</li>
                {
                  reports.vendorNames?.length && reports.vendorNames.map(item => (
                    <li aria-label="vendorName" onClick={onSelectDropdown} className={selectedValues.vendorName.toLowerCase() === item.broker_name.toLowerCase() ? "text-capitalize px-2 py-1 cursor-pointer fw-bold" : "text-capitalize px-2 py-1 cursor-pointer"}>{ item.broker_name?.toLowerCase() }</li>
                  ))
                }
              </ul>

            </div>
          </div>
          
          <div className="col-3">
          <p className="mb-1 text-capitalize report-dropdown-label">select date</p>
            <DatePicker
            calendarClassName='admin-daterange-calender'
            selectsRange={true}
            startDate={startDate}
            endDate={endDate}
            onChange={(update) => {
              setDateRange(update);
            }}
            className="date-range-input ps-2 mb-1 w-100 position-relative"
            dateFormat={'dd/MM/yyyy'}
            placeholderText='DD/MM/YYYY - DD/MM/YYYY'
          />
          </div>

          <div className="col-3 col-md-3 col-lg-2 col-xl-2">
            <p className="mb-1 text-capitalize report-dropdown-label">source</p>
            <div className="dropdown admin-dropdown select-source-dropdown w-100 my-1">
              <button className="btn dropdown-toggle w-100 text-start no-shadow dropdown-icon-shape dropdown-button-padding" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                { selectedValues.source.length ? selectedValues.source : 'All' }
              </button>
              
              <ul className="dropdown-menu w-100 dropdown-scroll background-white" aria-labelledby="dropdownMenuButton1">
                <li aria-label="source" onClick={onSelectDropdown} className={selectedValues.source === 'All' ? "text-capitalize px-2 py-1 cursor-pointer fw-bold" : "text-capitalize px-2 py-1 cursor-pointer"}>All</li>
                {
                  reports.sources.map(item => (
                    <li aria-label="source" onClick={onSelectDropdown} className={selectedValues.source.toLowerCase() === item?.src?.toLowerCase() ? "text-capitalize px-2 py-1 cursor-pointer fw-bold" : "text-capitalize px-2 py-1 cursor-pointer"}>{ item?.src?.toLowerCase() }</li>
                  ))
                }
              </ul>

            </div>
          </div>

          <div className="col-3 col-md-3 col-lg-2 col-xl-2">
            <p className="mb-1 text-capitalize report-dropdown-label">Account Status</p>
            <div className="dropdown admin-dropdown select-accountStatus-dropdown w-100 my-1">
              <button className="btn dropdown-toggle w-100 text-start no-shadow dropdown-icon-shape dropdown-button-padding" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                { selectedValues.accountStatus.length ? selectedValues.accountStatus : 'All' }
              </button>
              
              <ul className="dropdown-menu w-100 dropdown-scroll background-white" aria-labelledby="dropdownMenuButton1">
                <li aria-label="accountStatus" onClick={onSelectDropdown} className={selectedValues.accountStatus.toLowerCase() === 'all' ? "text-capitalize px-2 py-1 cursor-pointer fw-bold" : "text-capitalize px-2 py-1 cursor-pointer"}>All</li>
                {
                  reports.accountStatus.map(item => (
                    <li aria-label="accountStatus" onClick={onSelectDropdown} className={selectedValues.accountStatus.toLowerCase() === item.status.toLowerCase() ? "text-capitalize px-2 py-1 cursor-pointer fw-bold" : "text-capitalize px-2 py-1 cursor-pointer"}>{ item.status.toLowerCase() }</li>
                  ))
                }
              </ul>

            </div>
          </div>
          
          <div className="col-1 me-md-5 me-lg-0 mt-4 mt-lg-0 mt-xl-0">
            <button onClick={handleSubmitFilters} className='text-capitalize report-proceed-btn mb-1 text-white px-4'>proceed</button>
          </div>
         
          <div className="col-1 ms-2 ms-lg-4 ms-xl-4 mt-4 mt-lg-0 mt-xl-0">
            <button
              hidden={selectedValues.vendorName === 'All' && selectedValues.source === 'All' && selectedValues.accountStatus.length === 0}
              onClick={resetDropdowns}
              className='text-capitalize report-reset-btn mb-1 px-4'
            >reset</button>
          </div>
          
          
        </div>

        <div className="pt-3 reports-table-container">
          <div className="reports-table-actionbar py-3 row align-items-center justify-content-between px-4 no-row-margin">
          
            <div className='table-search-input-container position-relative col-6 col-md-7 col-lg-7 col-xl-6'>
              <input 
                onChange={handleSearch}
                type="text"
                placeholder='Search PAN, Mobile number, Name of investor, Application id, Dp id or Client id'
                className='w-100 ps-5'
                value={searchValue}
              />
            </div>

            <div className="col-3 col-md-3 col-lg-2 col-xl-2 text-end">
              <button onClick={onClickDownload} type='button' className='download-file-btn text-capitalize bg-white py-1 pe-2' disabled={ tableData.length === 0 && downloadData.length === 0 }>
                <img width="20px" height="20px" className='ms-2 me-2'  src={ downloadIcon } alt="download icon" />  
                download
              </button>
            </div>
              
          </div>
          <div className="bg-white px-4 mt-5 row no-row-margin">
              <div hidden={tableData.length === 0} className="col-12 reports-table-padding">
                <Table tableFor="reports" tableData={tableData} setFilteredDataToDownload={ setFilteredDataToDownload } />
              </div>
          </div>
        </div>
        <div className="mb-4 bg-white pb-4" hidden={!noData}>  
          <div className="mx-4 py-3 px-2 text-center table-nodata text-capitalize">No data found</div>
        </div>
      </div>
      
      <CModal
          ref={modalRef}
          callbackFunc={!reports.tokenExpired ? resetDropdowns  : handleLoginRedirection}
          onClickCancel={resetDropdowns}
      />
    </div>
  )
}

export default ReportsPage